import { useMemo } from "react";

import useSystem from "../api/hooks/useSystem";

import { useSystemIdFromRoute } from "./useSystemIdFromRoute";

export const DEFAULT_TIMEZONE = "America/Chicago";

export const useGetSystemTimeZone = () => {
  const systemId = useSystemIdFromRoute();
  const { system, loading } = useSystem({ systemId });
  return useMemo(
    () => ({ timeZone: system?.timeZone ?? DEFAULT_TIMEZONE, loading }),
    [loading, system?.timeZone],
  );
};
